const setHeight = () => {
  const els = document.querySelectorAll(".Page_2_col_media_content_block_text_container");

  if (window.innerWidth < 749) {
    els.forEach(el => el.style.height = "auto");
    return;
  }

  let max = 0;

  els.forEach(el => {
    el.style.height = "auto";
    max = Math.max(max, el.offsetHeight);
  });

  els.forEach(el => el.style.height = max + "px");
};

window.addEventListener("load", setHeight);
window.addEventListener("resize", () => {
  clearTimeout(window._rh);
  window._rh = setTimeout(setHeight, 150);
});